import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { DeclaracoesFiscaisMensais } from '../models/declaracoesFiscaisMensais.model';
import { environment } from '../../../src/app/environments/environment';
import { GerarDasRequest } from '../models/gerarDasRequest.model';

@Injectable({
  providedIn: 'root'
})
export class DeclaracoesFiscaisService {
  private apiUrlMensal = `${environment.advContabilApi}/api/IntegraContador/ListarEntregasDeclaracoesMensais`;
  private apiUrl = `${environment.advContabilApi}/api/IntegraContador`;

  private declaracaoSelecionadaSubject = new BehaviorSubject<DeclaracoesFiscaisMensais | null>(null);
  declaracaoSelecionada$ = this.declaracaoSelecionadaSubject.asObservable();

  constructor(private http: HttpClient) { }

  listarDeclaracoesMensais(usuarioId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrlMensal}?usuarioId=${usuarioId}`);
  }

  setDeclaracaoSelecionada(declaracao: DeclaracoesFiscaisMensais) {
    this.declaracaoSelecionadaSubject.next(declaracao);
  }

  clearDeclaracaoSelecionada() {
    this.declaracaoSelecionadaSubject.next(null);
  }

  gerarDas(request: GerarDasRequest): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/GerarDas`, request);
  }
}
